import { CustomField, CustomFieldDto } from './customFields';
import { DmsTeam } from './dmsTeam';
import { MinDto, NamedEntityMinDto } from './other';

// ==============================|| TEAM TYPES  ||============================== //
export enum TeamType {
    CORRESPONDENCE = 'CORRESPONDENCE',
    PRACTICE_GROUP = 'PRACTICE_GROUP',
    SECTOR_GROUP = 'SECTOR_GROUP',
}

export interface TeamEmployee extends NamedEntityMinDto {
    teamMembershipType?: string;
    isCoreEmployee: boolean;
    office: {
        id: number;
        name?: string;
    };
}

export interface Team {
    id: number;
    name: string;
    abbreviation: string | null;
    orderNum: number | null;
    teamTypeCode: string | null;
    isActive: boolean;
    parentTeam: NamedEntityMinDto | null;
    teamEmployees: TeamEmployee[];
    teamTypeLabel: string | null;
    teamPracticeAreas: NamedEntityMinDto[] | null;
    emailAddress: string | null;
    teamOffices: NamedEntityMinDto[] | null;
    isParent: boolean;
    teamBusinessAreas?: TeamBusinessArea[];
    customFields?: CustomField[];
    dmsTeamId?: string | null;
    dmsTeamName?: string | null;
    dmsTeamValid?: boolean | null;
    createdAt?: string;
    lastModifiedAt?: string | null;
    createdByEmployee?: MinDto;
    changedByEmployee?: MinDto;
    isDraft?: boolean;
}

export interface TeamMinDto {
    id: number;
    name: string;
    abbreviation: string;
}

// Interface to use when creating or updating a team
export interface TeamCreateDto {
    name: string | null;
    abbreviation: string | null;
    teamTypeCode: string | null;
    emailAddress: string | null;
    isActive: boolean;
    parentTeam: NamedEntityMinDto | number | null;
    teamPracticeAreas: NamedEntityMinDto[] | null;
    teamOffices: NamedEntityMinDto[] | null;
    isParent: boolean;
    teamBusinessAreas: string[];
    customFields?: CustomFieldDto[];
    dmsTeamId: string | null;
}

export interface TeamUpdateDto extends TeamCreateDto {
    id: string | number;
}

export interface TeamForm {
    name: string;
    abbreviation: string;
    teamType: { label: string; value: string } | null;
    isActive: boolean;
    parentTeam: NamedEntityMinDto | null;
    teamPracticeAreas: NamedEntityMinDto[] | null;
    emailAddress: string;
    readonlyTeamEmployees: TeamEmployee[];
    teamOffices: NamedEntityMinDto[];
    isParent: boolean;
    teamBusinessAreas: { label: string; value: string }[];
    dmsTeam: DmsTeam | null;
}

interface TeamBusinessArea {
    businessAreaTypeCode: string;
}
